import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Spinner } from '@vatman/ui';
import type { TrackerProject } from '../tracker/model';
import './spaces.css';

/** Tracker projects as cards: in a space, and in "Everything in the organization". */
export function ProjectCards({ projects, loading, onCreate }: { projects: TrackerProject[] | undefined; loading: boolean; onCreate?: () => void }) {
  const { t } = useTranslation();
  if (loading && !projects) return <Spinner />;
  const list = (projects ?? []).filter((p) => !p.archived);
  if (!list.length) {
    return (
      <div className="empty-state">
        <h3>{t('spaces.noProjects')}</h3>
        {onCreate && (
          <>
            <div>{t('spaces.noProjectsHint')}</div>
            <button className="btn primary" onClick={onCreate}>
              <Plus size={16} /> {t('tracker.newProject')}
            </button>
          </>
        )}
      </div>
    );
  }
  return (
    <div className="space-projects">
      {list.map((p) => (
        <Link key={p.id} to={`/t/${p.id}`} className="space-project">
          <span className="space-project-key">{p.key}</span>
          <span className="space-project-name">{p.name}</span>
          {p.description && <span className="muted space-project-desc">{p.description}</span>}
        </Link>
      ))}
    </div>
  );
}
